import { render, staticRenderFns } from "./CheckboxMultiselect.vue?vue&type=template&id=048b837c&"
import script from "./CheckboxMultiselect.vue?vue&type=script&lang=js&"
export * from "./CheckboxMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports